import styled, { css } from 'styled-components'
import { getStyles, textStylesConfig } from '@styles/vars/textStyles.style'

const fontSizeMax = textStylesConfig.body2.size.max
const inputTextStyles = css`
  ${getStyles({ ...textStylesConfig.body2 })}
`

export const InputWrapper = styled.div`
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    display: block;
    height: 0.1rem;
    background-color: currentColor;
    opacity: 0.3;
  }
`

export const InputMain = styled.input`
  appearance: none;
  display: block;
  width: 100%;
  padding-bottom: ${20 / fontSizeMax}em;
  ${inputTextStyles}
  color: currentColor;
  border: none;
  background-color: transparent;
  &:focus-visible {
    outline: unset;
  }
`

export const InputLabel = styled.label`
  position: absolute;
  top: 50%;
  left: 0;
  transform-origin: 0% 0%;
  transform: translateY(-50%);
  ${inputTextStyles}
  transition: transform 0.15s ease, opacity 0.15s ease;
  will-change: transform, opacity;

  ${InputWrapper}:focus-within &,
  ${InputMain}:not(:placeholder-shown) + & {
    transform: translateY(-134%) scale(0.6);
    opacity: 0.6;
  }
  pointer-events: none;
`
